// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__LIdJf","icon":"SortAdornment_icon__2d6ef","up":"SortAdornment_up__pUB3P","down":"SortAdornment_down__2o5uE","active":"SortAdornment_active___9TWW"};